var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "handle-wrapper"
  }, [_c('Button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function ($event) {
        return _vm.$refs.EditFactoryDrawer.openDrawer();
      }
    }
  }, [_vm._v("新增工厂")])], 1), _c('div', {
    ref: "tableWrapper",
    staticClass: "table-wrapper"
  }, [_c('Table', {
    attrs: {
      "border": "",
      "columns": _vm.columns,
      "data": _vm.tableData,
      "height": _vm.tableHeight
    }
  })], 1), _c('EditFactoryDrawer', {
    ref: "EditFactoryDrawer",
    attrs: {
      "factoryList": _vm.tableData
    }
  })], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }